import { createSlice } from '@reduxjs/toolkit';
import { fetchAllNotificaitonsThunk, markReadUnreadNotificaitonThunk } from '../../redux/thunks/notification';
import { NotificaitonObject, NotificationState } from '../../params/redux/notification';

// Initial state with default values for authentication and user info
const initialState: NotificationState = {
    notifications: [],
    loaders: {
        isLoading: false,
        isCreating: false,
        isUpdating: false,
        isDeleting: false,
        isSearching: false,
        isInserting: false
    }
};

// Slice for app-related states and actions
const notificationSlice = createSlice({
    // Slice name
    name: 'notification',
    // inital state for the slice
    initialState,
    reducers: {
        toggleNotificationReadState: (state, action) => {
            const { notification_id, is_read } = action.payload;
            const index = state.notifications.findIndex((n) => n.id === notification_id);
            if (index !== -1) {
                state.notifications[index].is_read = is_read;
            }
        },
        resetNotificationState: (state, action) => {
            state.notifications = action.payload;
        },
        // Resets loading states related to app actions
        resettingNotificaitonLoader: (state) => {
            state.loaders = initialState.loaders;
        },
        // Resets all app data to the initial state
        resettingNotificaitonData: () => JSON.parse(JSON.stringify(initialState))
    },
    extraReducers: (builder) => {
        // Handle async actions for login
        builder
            .addCase(fetchAllNotificaitonsThunk.pending, (state) => {
                // Set loading flag during login request
                state.loaders.isLoading = true;
            })
            .addCase(fetchAllNotificaitonsThunk.fulfilled, (state, action) => {
                state.notifications = action.payload as NotificaitonObject[];
            })
            .addCase(fetchAllNotificaitonsThunk.rejected, (state) => {
                state.notifications = [];
            });
            builder
            .addCase(markReadUnreadNotificaitonThunk.pending, (state) => {
                // Set loading flag during login request
                state.loaders.isLoading = true;
            })
            .addCase(markReadUnreadNotificaitonThunk.fulfilled, () => {
                //
            })
            .addCase(markReadUnreadNotificaitonThunk.rejected, () => {
                //
            });
    }
});

// Exporting actions for updating app state
export const {
    resetNotificationState,
    toggleNotificationReadState,
    resettingNotificaitonData,
    resettingNotificaitonLoader
} = notificationSlice.actions;

// Exporting the reducer to be used in the store
export default notificationSlice.reducer;
